import { render } from "./Vendors.vue?vue&type=template&id=0fc25847"
import script from "./Vendors.vue?vue&type=script&lang=js"
export * from "./Vendors.vue?vue&type=script&lang=js"

import "./Vendors.vue?vue&type=style&index=0&id=0fc25847&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__